import React, { useState } from 'react';

import {
  Box,
  Button,
  Paper
} from '@mui/material';

import {
  Add,
  ChevronLeft,
  ChevronRight
} from '@mui/icons-material';

import AppointmentFilters from './AppointmentFilters';
import DaySchedule from './DaySchedule';

const AppointmentContent = ({ onSchedule }) => { 
  const [view, setView] = useState('day');

  return (
    <Paper
      sx={{
        minHeight: 762,
        borderRadius: '8px',
        border: '1px solid #D9D9D9',
        boxShadow: 'none',
        overflow: 'hidden'
      }}
    >
      <AppointmentFilters />

      <Box
        sx={{
          minHeight: 50,
          px: 1.5,
          display: 'grid',
          gridTemplateColumns: '1fr auto 1fr',
          alignItems: 'center',
          bgcolor: '#FAFAFA',
          borderBottom: '1px solid #E0E0E0'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <Button
            size="small"
            startIcon={<ChevronLeft />}
            sx={{
              color: '#424242',
              minWidth: 50,
              fontSize: 12
            }}
          >
            Today
          </Button>

          <ChevronRight
            sx={{
              fontSize: 18,
              color: '#616161'
            }}
          />
        </Box>

        <Box
          sx={{
            fontSize: 14,
            fontWeight: 500,
            color: '#424242'
          }}
        >
          July 24, 2026
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 0.75
          }}
        >
          {[
            {
              key: 'day',
              label: 'DAY'
            },
            {
              key: 'week',
              label: 'WEEK'
            },
            {
              key: 'agenda',
              label: 'AGENDA'
            }
          ].map(item => (
            <Button
              key={item.key}
              size="small"
              variant={
                view === item.key
                  ? 'contained'
                  : 'outlined'
              }
              onClick={() =>
                setView(item.key)
              }
              sx={{
                minWidth: item.key === 'agenda'
                  ? 68
                  : 50,
                height: 28,
                px: 1,
                fontSize: 11,
                boxShadow: 'none',
                borderColor: '#D9D9D9',
                color:
                  view === item.key
                    ? '#424242'
                    : '#424242',
                bgcolor:
                  view === item.key
                    ? '#E0E0E0'
                    : '#FFFFFF',
                '&:hover': {
                  bgcolor:
                    view === item.key
                      ? '#D5D5D5'
                      : '#FAFAFA',
                  borderColor: '#D9D9D9',
                  boxShadow: 'none'
                }
              }}
            >
              {item.label}
            </Button>
          ))}
        </Box>
      </Box>

      <DaySchedule />
    </Paper>
  );
};

export default AppointmentContent;